import Vue, { VueConstructor } from "vue";

import { formatDate } from "./datetime";
import { getPatientFullName } from "./patientName";

export function registerFilters(vue: VueConstructor<Vue>) {
  vue.filter("date", formatDate);
  vue.filter("getPatientFullName", getPatientFullName);
}
